module.exports = __webpack_public_path__ + "img/a11y-support_jp.f78e70c.jpg";